"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 2019-04-11
 */

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var PriceFormulas_1 = require("../../../core/model/math/PriceFormulas");

var utils_1 = require("../../../core/utils");
/**
 * Partial sums for sellout impact attributes that can be aggregated into {@link SelloutImpactRecord} (LOG-3103).
 * @author Radek Beran
 * @author JMr
 */


var SelloutImpactRecordSums =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutImpactRecordSums, _DomainObject_1$Domai);

  function SelloutImpactRecordSums(id, releaseId, categoryId, reopen, // PROFACT-312
  selloutProductsCount, sites, priceChangesCount, discountPercentUpperSum, discountPercentWeightSum, marginOldUpperSum, marginOldWeightSum, marginNewUpperSum, marginChangeUpperSum, marginChangePercentUpperSum, marginChangePercentWeightSum, profitOldUpperSum, profitOldWeightSum, profitNewUpperSum, profitNewWeightSum, profitImpactUpperSum, profitImpactPercentUpperSum, profitImpactPercentWeightSum, minPriceChangeInPercentUpperSum, minPriceChangeInPercentWeightSum, maxPriceChangeInPercentUpperSum, maxPriceChangeInPercentWeightSum, minMarginChangeInPercentUpperSum, minMarginChangeInPercentWeightSum, availableSupplyPriceSum, availableSupplySum, availableSupplyBeforeRepricingPriceSum, availableSupplyBeforeRepricingSum, deadstockProvisionDiscountPercentUpperSum, deadstockProvisionDiscountPercentWeightSum, deadstockProvisionUpperSum, deadstockProvisionWeightSum, deadstockInvestmentUpperSum, deadstockInvestmentWeightSum, deadstockImpactUpperSum, deadstockImpactWeightSum, estimationInPercentSum, estimationInPercentWeightSum, // Quantity (volumes)
  salesVolumeOldSum, salesVolumeNewSum, // Sales (revenues)
  revenueOldSum, revenueNewSum) {
    var _this;

    _classCallCheck(this, SelloutImpactRecordSums);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactRecordSums).call(this));
    _this.id = id;
    _this.releaseId = releaseId;
    _this.categoryId = categoryId;
    _this.reopen = reopen;
    _this.selloutProductsCount = selloutProductsCount;
    _this.sites = sites;
    _this.priceChangesCount = priceChangesCount;
    _this.discountPercentUpperSum = discountPercentUpperSum;
    _this.discountPercentWeightSum = discountPercentWeightSum;
    _this.marginOldUpperSum = marginOldUpperSum;
    _this.marginOldWeightSum = marginOldWeightSum;
    _this.marginNewUpperSum = marginNewUpperSum;
    _this.marginChangeUpperSum = marginChangeUpperSum;
    _this.marginChangePercentUpperSum = marginChangePercentUpperSum;
    _this.marginChangePercentWeightSum = marginChangePercentWeightSum;
    _this.profitOldUpperSum = profitOldUpperSum;
    _this.profitOldWeightSum = profitOldWeightSum;
    _this.profitNewUpperSum = profitNewUpperSum;
    _this.profitNewWeightSum = profitNewWeightSum;
    _this.profitImpactUpperSum = profitImpactUpperSum;
    _this.profitImpactPercentUpperSum = profitImpactPercentUpperSum;
    _this.profitImpactPercentWeightSum = profitImpactPercentWeightSum;
    _this.minPriceChangeInPercentUpperSum = minPriceChangeInPercentUpperSum;
    _this.minPriceChangeInPercentWeightSum = minPriceChangeInPercentWeightSum;
    _this.maxPriceChangeInPercentUpperSum = maxPriceChangeInPercentUpperSum;
    _this.maxPriceChangeInPercentWeightSum = maxPriceChangeInPercentWeightSum;
    _this.minMarginChangeInPercentUpperSum = minMarginChangeInPercentUpperSum;
    _this.minMarginChangeInPercentWeightSum = minMarginChangeInPercentWeightSum;
    _this.availableSupplyPriceSum = availableSupplyPriceSum;
    _this.availableSupplySum = availableSupplySum;
    _this.availableSupplyBeforeRepricingPriceSum = availableSupplyBeforeRepricingPriceSum;
    _this.availableSupplyBeforeRepricingSum = availableSupplyBeforeRepricingSum;
    _this.deadstockProvisionDiscountPercentUpperSum = deadstockProvisionDiscountPercentUpperSum;
    _this.deadstockProvisionDiscountPercentWeightSum = deadstockProvisionDiscountPercentWeightSum;
    _this.deadstockProvisionUpperSum = deadstockProvisionUpperSum;
    _this.deadstockProvisionWeightSum = deadstockProvisionWeightSum;
    _this.deadstockInvestmentUpperSum = deadstockInvestmentUpperSum;
    _this.deadstockInvestmentWeightSum = deadstockInvestmentWeightSum;
    _this.deadstockImpactUpperSum = deadstockImpactUpperSum;
    _this.deadstockImpactWeightSum = deadstockImpactWeightSum;
    _this.estimationInPercentSum = estimationInPercentSum;
    _this.estimationInPercentWeightSum = estimationInPercentWeightSum;
    _this.salesVolumeOldSum = salesVolumeOldSum;
    _this.salesVolumeNewSum = salesVolumeNewSum;
    _this.revenueOldSum = revenueOldSum;
    _this.revenueNewSum = revenueNewSum;
    return _this;
  }

  _createClass(SelloutImpactRecordSums, null, [{
    key: "initial",
    value: function initial(releaseId, categoryId) {
      return new SelloutImpactRecordSums(utils_1.Utils.VOID_ID, releaseId, categoryId, null, 0, immutable_1.Set.of(), 0, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO);
    }
  }]);

  return SelloutImpactRecordSums;
}(DomainObject_1.DomainObject);

exports.SelloutImpactRecordSums = SelloutImpactRecordSums;

SelloutImpactRecordSums.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutImpactRecordSums.name);
  return {
    id: builder.id('id'),
    releaseId: builder.str('releaseId'),
    categoryId: builder.str('categoryId'),
    reopen: builder.opt(builder.num('reopen')),
    selloutProductsCount: builder.num('selloutProductsCount'),
    sites: builder.setOf(builder.id('sites')),
    priceChangesCount: builder.num('priceChangesCount'),
    discountPercentUpperSum: builder.bigNum('discountPercentUpperSum'),
    discountPercentWeightSum: builder.bigNum('discountPercentWeightSum'),
    marginOldUpperSum: builder.bigNum('marginOldUpperSum'),
    marginOldPercentUpperSum: builder.bigNum('marginOldPercentUpperSum'),
    marginOldWeightSum: builder.bigNum('marginOldWeightSum'),
    marginNewUpperSum: builder.bigNum('marginNewUpperSum'),
    marginNewPercentUpperSum: builder.bigNum('marginNewPercentUpperSum'),
    marginNewPercentWeightSum: builder.bigNum('marginNewPercentWeightSum'),
    marginChangeUpperSum: builder.bigNum('marginChangeUpperSum'),
    marginChangePercentUpperSum: builder.bigNum('marginChangePercentUpperSum'),
    marginChangePercentWeightSum: builder.bigNum('marginChangePercentWeightSum'),
    profitOldUpperSum: builder.bigNum('profitOldUpperSum'),
    profitOldPercentUpperSum: builder.bigNum('profitOldPercentUpperSum'),
    profitOldWeightSum: builder.bigNum('profitOldWeightSum'),
    profitNewUpperSum: builder.bigNum('profitNewUpperSum'),
    profitNewPercentUpperSum: builder.bigNum('profitNewPercentUpperSum'),
    profitNewWeightSum: builder.bigNum('profitNewWeightSum'),
    profitImpactUpperSum: builder.bigNum('profitImpactUpperSum'),
    profitImpactPercentUpperSum: builder.bigNum('profitImpactPercentUpperSum'),
    profitImpactPercentWeightSum: builder.bigNum('profitImpactPercentWeightSum'),
    minPriceChangeInPercentUpperSum: builder.bigNum('minPriceChangeInPercentUpperSum'),
    minPriceChangeInPercentWeightSum: builder.bigNum('minPriceChangeInPercentWeightSum'),
    maxPriceChangeInPercentUpperSum: builder.bigNum('maxPriceChangeInPercentUpperSum'),
    maxPriceChangeInPercentWeightSum: builder.bigNum('maxPriceChangeInPercentWeightSum'),
    minMarginChangeInPercentUpperSum: builder.bigNum('minMarginChangeInPercentUpperSum'),
    minMarginChangeInPercentWeightSum: builder.bigNum('minMarginChangeInPercentWeightSum'),
    availableSupplyPriceSum: builder.bigNum('availableSupplyPriceSum'),
    availableSupplySum: builder.bigNum('availableSupplySum'),
    availableSupplyBeforeRepricingPriceSum: builder.bigNum('availableSupplyBeforeRepricingPriceSum'),
    availableSupplyBeforeRepricingSum: builder.bigNum('availableSupplyBeforeRepricingSum'),
    deadstockProvisionDiscountPercentUpperSum: builder.bigNum('deadstockProvisionDiscountPercentUpperSum'),
    deadstockProvisionDiscountPercentWeightSum: builder.bigNum('deadstockProvisionDiscountPercentWeightSum'),
    deadstockProvisionUpperSum: builder.bigNum('deadstockProvisionUpperSum'),
    deadstockProvisionWeightSum: builder.bigNum('deadstockProvisionWeightSum'),
    deadstockInvestmentUpperSum: builder.bigNum('deadstockInvestmentUpperSum'),
    deadstockInvestmentWeightSum: builder.bigNum('deadstockInvestmentWeightSum'),
    deadstockImpactUpperSum: builder.bigNum('deadstockImpactUpperSum'),
    deadstockImpactWeightSum: builder.bigNum('deadstockImpactWeightSum'),
    estimationInPercentSum: builder.bigNum('estimationInPercentSum'),
    estimationInPercentWeightSum: builder.bigNum('estimationInPercentWeightSum'),
    salesVolumeOldSum: builder.bigNum('salesVolumeOldSum'),
    salesVolumeNewSum: builder.bigNum('salesVolumeNewSum'),
    revenueOldSum: builder.bigNum('revenueOldSum'),
    revenueNewSum: builder.bigNum('revenueNewSum')
  };
}();